export function checkIfRoutePatternIncludesFields(routePattern: string) {
  const BEGINNING_OF_FIELD_INCLUSION = '{'
  return routePattern.includes(BEGINNING_OF_FIELD_INCLUSION)
}
